import type { KeyboardEvent, MouseEvent } from 'react';
import { createContext } from 'react';

import noop from '@lokalise/ui/utils/noop';

const Context = createContext<{
    onClose: (event: MouseEvent | KeyboardEvent) => void;
}>({
    onClose: noop,
});

export const { Provider } = Context;

export default Context;
